export default __webpack_public_path__ + "static/media/medium.eec88101.svg";